import { render, staticRenderFns } from "./AssignModal.vue?vue&type=template&id=63ea5328&lang=pug&"
import script from "./AssignModal.vue?vue&type=script&lang=js&"
export * from "./AssignModal.vue?vue&type=script&lang=js&"
import style0 from "./AssignModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports